var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3e%3cpath fill='white' d='M0 0h3v2H0z'/%3e%3cpath fill='%23CE1126' d='M0 0h3v1H0z'/%3e%3c/svg%3e";
  export default img;